/**
 * @file コンポーネント：フル動画ページタイムラインコメント スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledComment = styled.div``;

export const StyledCommentText = styled.div`
    color: #ffffff;
    font-size: 11px;
    line-height: 16px;

    ${mediaQuery.pc(`
        font-size: 12px;
        line-height: 18px;
    `)};

    ${mediaQuery.pcWide(`
        font-size: 12px;
        line-height: 18px;
    `)};
`;

export const StyledCommentTime = styled.div`
    margin-bottom: 8px;
    color: #7f97f8;
    font-weight: bold;
    font-size: 11px;
    line-height: 16px;

    ${mediaQuery.pc(`
        font-size: 12px;
        line-height: 18px;
    `)};

    ${mediaQuery.pcWide(`
        font-size: 12px;
        line-height: 18px;
    `)};
`;
